<!-- 创建联盟 -->
<template>
    <div v-loading="loading">
        <div class="union-form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <el-form-item label="联盟名称" prop="Name">
                    <el-input v-model="formData.Name" :maxlength="80" placeholder="请输入联盟名称，尽量不要太长哟"></el-input>
                </el-form-item>
                <el-form-item label="简称" prop="Abbr">
                    <el-input v-model="formData.Abbr" :maxlength="6" placeholder="请输入简称，用于首页展示，长度最多为6个字"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="Contactor">
                    <el-input v-model="formData.Contactor" :maxlength="20" placeholder="请输入联盟联系人名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="PhoneNum">
                    <el-input v-model="formData.PhoneNum" :maxlength="20" placeholder="请输入联盟联系人电话/手机"></el-input>
                </el-form-item>
                <el-form-item label="主营配件">
                    <el-input v-model="formData.MainPartName" placeholder="请输入联盟主营配件"></el-input>
                </el-form-item>
                <el-form-item label="主营车型">
                    <el-input v-model="formData.MainVehicle" placeholder="格式：品牌 + 车系"></el-input>
                </el-form-item>
                <el-form-item label="是否开放申请">
                    <el-radio-group v-model="formData.IsCanApply">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="联盟Logo" prop="UnionLogo">
                    <div class="img-upload">
                        <el-button class="btn-primary btn-upload" @click="uplaodClick">上传联盟Logo</el-button>
                        <input type="file" style="display: none" id="chooseImgBtn" @change="uploadImg" />
                        <div class="preview">
                            <img :src="formData.UnionLogo ? downloadUrl + formData.UnionLogo : ''" alt :onerror="defaultImg" />
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button class="btn-primary" @click="submitForm">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import uploadFile from '../../../assets/js/uploadFile';
export default {
    props: ['UnionId'],
    components: {},
    name: '',
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
            downloadUrl: this.$util.QN_URL_BASE,
            userMsg: userMsg,
            formData: {
                UnionId: '',
                Name: '',
                Abbr: '',
                Contactor: '',
                PhoneNum: '',
                UnionLogo: '',
                MainVehicle: '',
                MainPartName: '',
                IsCanApply: false
            },
            rules: {
                Name: [
                    {
                        required: true,
                        message: '联盟名称必须填写',
                        trigger: 'blur'
                    }
                ],
                Contactor: [
                    {
                        required: true,
                        message: '联系人名称必须填写，方便联盟成员联系',
                        trigger: 'blur'
                    }
                ],
                Abbr: [
                    {
                        required: true,
                        message: '联盟简称为必填项，用于首页中的展示',
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                UnionLogo: [
                    {
                        required: true,
                        message: '联盟Logo必须要上传哟',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.UnionId) this.GetUnionDatas();
    },
    methods: {
        GetUnionDatas() {
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetUnionDataDetails',
                    data: {
                        UnionId: this.UnionId
                    }
                })
                .then(res => {
                    let data = res.data;

                    this.formData.UnionId = data.UnionId;
                    this.formData.Name = data.UnionName;
                    this.formData.Abbr = data.Abbr;
                    this.formData.Contactor = data.Contact;
                    this.formData.PhoneNum = data.PhoneNum;
                    this.formData.UnionLogo = data.LogoUrl;
                    this.formData.MainVehicle = data.MainManageSeries;
                    this.formData.MainPartName = data.MainManageAutoParts;
                    this.formData.IsCanApply = data.IsCanApply;
                });
        },
        // 提交表单
        submitForm() {
            this.$refs.formData.validate(valid => {
                let that = this;
                if (valid) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpUnions/CreateUnions',
                            data: that.formData,
                            hideLoading: true
                        })
                        .then(res => {
                            that.$util.successMsg(res.errmsg);
                            that.$emit('closeDialog', true);
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        // 点击上传按钮
        uplaodClick: function () {
            let btn = document.getElementById('chooseImgBtn');
            btn.click();
        },
        // 上传logo
        uploadImg() {
            let that = this;
            uploadFile({
                id: 'chooseImgBtn', // 上传按钮id
                url: this.$util.BASE_URL + '/UploadFile/UploadSingle',
                type: 'jpg,png,jpeg,gif', // 上传文件的后缀名,用英文逗号隔开
                maxSize: 20 * 1024, // 文件最大大小，单位KB
                progressCtn: '', // 显示进度条的容器id，样式自己写
                nameMaxLen: 80, //名字最长字符数
                token: that.userMsg.Token,
                data: {
                    // 要带过去的参数
                    key: 'Logo-UnionLogo',
                    isPrivate: false
                },
                // 上传成功后执行
                success: function (response) {
                    let res = JSON.parse(response);
                    if (res.errcode == 0) {
                        that.$set(that.formData, 'UnionLogo', res.fileUrl);
                    } else {
                        that.$util.errorMsg(res.errmsg);
                    }
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.union-form-main {
    height: auto;
}
.dialog-footer {
    text-align: right;
}

.img-upload {
    display: flex;
    flex-direction: row;
}

.btn-upload {
    height: 40px;
    margin-right: 20px;
}

.preview {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 110px;
    height: 110px;
    border: 1px solid @border4Color;
    border-radius: 10px;
    display: flex;
    align-items: center;
    overflow: hidden;
    img {
        max-width: 110px;
        max-height: 110px;
    }
}
</style>
